<!-- Start: Dropdown -->
<app-element-container
  [element]="element"
  [index]="index"
  [hasEntries]="hasEntries"
  [allElements]="allElements"
  [showCompletionWarning]="showCompletionWarning"
  (remove)="elementRemove.emit(element)"
  (manage)="elementManage.emit(element)"
  (moveUp)="elementMoveUp.emit(element)"
  (moveDown)="elementMoveDown.emit(element)"
  (addMessage)="messageAdd.emit(element)"
  (editMessage)="messageEdit.emit($event)"
  (removeMessage)="messageRemove.emit($event)"
  (visibilityEdit)="visibilityEdit.emit(element)">
  <div class="form-element-answer dropdown">
    <app-dropdown-input #dropdown
                        [options]="dropdownOptions"
                        [placeholder]="element.placeholder">
    </app-dropdown-input>
  </div>
</app-element-container>
<!-- End: Dropdown -->
